/**
 * Created by Administrator on 2018/5/9.
 */
import request from '@/utils/request';


let server = {
  myFavorites: '/favorites?include=gallery', // 我的收藏列表
  collectionGood: '/goods', // 点击收藏商品
  collectionCancel: '/goods', // 取消收藏
};



//  我的收藏列表
export function myFavorites() {
  return request({
    url: server.myFavorites,
    method: 'get'
  })
}


//  点击收藏商品
export function collectionGood(id) {
  return request({
    url: server.collectionGood + '/' +　id +　'/favorite',
    method: 'post'
  })
}


//  取消收藏商品
export function collectionCancel(id) {
  return request({
    url: server.collectionCancel+ '/' +　id + '/unfavorite',
    method: 'post',
  })
}








// WEBPACK FOOTER //
// ./src/api/collection.js